import { LILAC_400, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getImageContainerStyles = (isMobileScreen, type) => {
  var spacingToken = tokens.spacing;
  var isOTTType = type == 'OTT' && isMobileScreen;
  var benefitsImagesDimensions = isMobileScreen ? {
    width: 28,
    height: 28
  } : {
    width: 32,
    height: 32
  };
  return StyleSheet.create({
    benefitsContainer: {
      width: isOTTType ? '100%' : 3 * (benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width) * 0.8,
      height: 2 * (benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height),
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    benefitImage: {
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4,
      backgroundColor: 'blue',
      width: (benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width) * 0.9,
      height: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height,
      marginBottom: spacingToken.SPACING_4,
      marginRight: spacingToken.SPACING_4
    },
    hiddenBenefitsCountContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: LILAC_400,
      borderRadius: spacingToken.SPACING_4,
      width: (benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width) * 0.9,
      height: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height
    }
  });
};